var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../action/au.action';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { ContentBaseComponent } from '../base/contentbase.component';
import { ContentBaseService } from '../base/contentbase.service';
var DivComponent = /** @class */ (function (_super) {
    __extends(DivComponent, _super);
    function DivComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.defMode = '';
        return _this;
    }
    DivComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    DivComponent.prototype.onInit = function (meta) {
        _super.prototype.onInit.call(this, meta);
        if (this.component.params && this.component.params.mode) {
            this.defMode = this.component.params.mode;
        }
        if (this.defMode && this.component.components) {
            for (var _i = 0, _a = this.component.components; _i < _a.length; _i++) {
                var component = _a[_i];
                $.extend(true, component, { params: { mode: this.defMode } });
            }
        }
    };
    DivComponent.prototype.setUnsubscribe = function () {
        this.eventSubscription.unsubscribe();
        this.refSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    DivComponent.prototype.onEvent = function (e1, e2, rec) {
    };
    DivComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'division',
                    template: "<div *ngIf=\"defMode === '' || defMode === mode\" id=\"{{ componentName }}\" [comp]=\"component\" divDir>\n  <content *ngFor=\"let component of component.components\" [component]=\"component\"></content>\n</div>\n"
                }] }
    ];
    /** @nocollapse */
    DivComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: ContentBaseService }
    ]; };
    return DivComponent;
}(ContentBaseComponent));
export { DivComponent };
//# sourceMappingURL=div.component.js.map